import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/@shared';

/**
 * The different clients
 */
import { ClientWastemanagementModule } from './clients/wastemanagement/client-wastemanagement.module';
import { ClientPaepaeModule } from './clients/paepae/client-paepae.module';
import { ClientWaikatotainuiModule } from './clients/waikatotainui/client-waikatotainui.module';
import { ClientPatuharakekeModule } from './clients/patuharakeke/client-patuharakeke.module';
import { ClientTahaaroaModule } from './clients/tahaaroa/client-tahaaroa.module';
import { ClientDefaultModule } from './clients/default/client-default.module';
import { ClientWaitahaModule } from './clients/waitaha/client-waitaha.module';
import { ClientNgatiKuriModule } from './clients/ngatikuri/client-ngatikuri.module';
import { ClientNgatiAwaTaiKapitiModule } from './clients/ngatiawataikapiti/client-ngatiawataikapiti.module';
import { ClientKapitiModule } from './clients/kapiti/client-kapiti.module';
import { ClientTapuikaModule } from './clients/tapuika/client-tapuika.module';
import { ClientMaahangaModule } from './clients/maahanga/client-maahanga.module';
import { ClientNgatiHauitiModule } from './clients/ngatihauiti/client-ngatihauiti.module';
import { ClientNgaWairikiNgatiApaModule } from './clients/ngawairikingatiapa/client-ngawairikingatiapa.module';
import { ClientRananaModule } from './clients/ranana/client-ranana.module';
import { ClientNgatiManuhiriModule } from './clients/ngatimanuhiri/client-ngatimanuhiri.module';
import { ClientNgatiIraModule } from './clients/ngatiira/client-ngatiira.module';
import { ClientHurakiaTrustModule } from './clients/hurakiatrust/client-hurakiatrust.module';
import { ClientTeAratakiModule } from './clients/tearataki/client-tearataki.module';
import { ClientTeUriOHauModule } from './clients/teuriohau/client-te-uri-o-hau.module';
import { ClientRaukawaModule } from './clients/raukawa/client-raukawa.module';

import { ClientResolverMainLayoutComponent } from './resolvers/main-layout-resolver.component';
import { ClientResolverFilterDrawerLayoutComponent } from './resolvers/filter-drawer-layout-resolver.component';
import { ClientResolverTaiaoDashboardLayoutComponent } from './resolvers/taiao-dashboard-layout-resolver.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    /**
     * Client modules
     */
    ClientDefaultModule,
    ClientPaepaeModule,
    ClientWastemanagementModule,
    ClientWaikatotainuiModule,
    ClientTahaaroaModule,
    ClientPatuharakekeModule,
    ClientWaitahaModule,
    ClientNgatiKuriModule,
    ClientTapuikaModule,
    ClientMaahangaModule,
    ClientNgatiAwaTaiKapitiModule,
    ClientKapitiModule,
    ClientNgatiHauitiModule,
    ClientNgaWairikiNgatiApaModule,
    ClientRananaModule,
    ClientNgatiManuhiriModule,
    ClientNgatiIraModule,
    ClientHurakiaTrustModule,
    ClientTeAratakiModule,
    ClientTeUriOHauModule,
    ClientRaukawaModule,
  ],
  declarations: [
    ClientResolverMainLayoutComponent,
    ClientResolverFilterDrawerLayoutComponent,
    ClientResolverTaiaoDashboardLayoutComponent,
  ],
})
export class ClientModule {}
